import Icon from '../components/Icon';

const CollBeaches = Icon(
  'coll-beaches',
  <>
    <path d="M14.57 2.57c1.74.32 2 2.57 3 2.57s1.3-2.26 3.05-2.57C23.58 2.03 24 0 24 0h-2.88c-2.27 0-2.71 1.19-3.55 2.14C16.73 1.19 16.28 0 14.02 0h-2.88s.47 2.04 3.43 2.57ZM19.71 13.71a2.57 2.57 0 0 1 2.57-2.57s-1.29-3.43-4.71-3.43c-1.71 0-3.13.99-4.71 2.57C9 14.14 6 16.28 0 16.28v5.11c0 1.44 1.16 2.6 2.6 2.6 1.68 0 2.41-1.71 3.4-1.71.99 0 2.01 1.71 3 1.71.99 0 2.01-1.71 3-1.71.99 0 2.01 1.71 3 1.71.99 0 2.01-1.71 3-1.71.99 0 1.71 1.71 3.4 1.71h.03A2.57 2.57 0 0 0 24 21.42v-5.14h-1.71a2.57 2.57 0 0 1-2.57-2.57h-.01ZM3.43 8.57c1.74.32 2 2.57 3 2.57s1.3-2.26 3.05-2.57C12.44 8.03 12.86 6 12.86 6H9.98C7.71 6 7.27 7.19 6.43 8.14 5.59 7.19 5.14 6 2.88 6H0s.47 2.04 3.43 2.57Z" />
  </>
);

export default CollBeaches;
